import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "land-sub-public-page" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "content-section about-section"
}
const _hoisted_8 = { class: "about-content" }
const _hoisted_9 = {
  key: 2,
  class: "content-section features-section"
}
const _hoisted_10 = { class: "features-content" }
const _hoisted_11 = { class: "features-grid" }
const _hoisted_12 = {
  key: 3,
  class: "content-section documents-section"
}
const _hoisted_13 = { class: "documents-content" }
const _hoisted_14 = { class: "documents-list" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "document-copy" }
const _hoisted_17 = {
  key: 4,
  class: "content-section contact-section"
}
const _hoisted_18 = { class: "contact-content" }
const _hoisted_19 = { class: "contact-grid" }
const _hoisted_20 = { class: "contact-person" }
const _hoisted_21 = ["src"]
const _hoisted_22 = {
  key: 1,
  class: "photo-placeholder"
}
const _hoisted_23 = { class: "contact-details" }
const _hoisted_24 = ["href"]
const _hoisted_25 = ["href"]
const _hoisted_26 = ["href"]
const _hoisted_27 = { class: "map-placeholder" }
const _hoisted_28 = { class: "location-copy" }
const _hoisted_29 = { class: "cta-content" }
const _hoisted_30 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", {
      class: "hero-section",
      style: _normalizeStyle($setup.heroStyle)
    }, [
      ($setup.content.projectLogoUrl)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "project-logo",
            src: $setup.content.projectLogoUrl,
            alt: "Project logo"
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString($setup.content.projectName || "Land Subdivision"), 1)),
      _createElementVNode("a", {
        class: "hero-availability-button",
        href: $setup.masterplanUrl,
        style: _normalizeStyle($setup.heroButtonStyle)
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("span", null, "View Land Availability", -1)),
        _createVNode($setup["ArrowRight"], { size: 18 })
      ], 12, _hoisted_4)
    ], 4),
    ($setup.content.agency?.name || $setup.content.agency?.logoUrl)
      ? (_openBlock(), _createElementBlock("section", {
          key: 0,
          class: "agency-bar",
          style: _normalizeStyle($setup.agencyBarStyle)
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, "Proudly marketed by", -1)),
          ($setup.content.agency?.logoUrl)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: $setup.content.agency.logoUrl,
                alt: "Agency logo"
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("strong", _hoisted_6, _toDisplayString($setup.content.agency?.name), 1))
        ], 4))
      : _createCommentVNode("", true),
    ($setup.content.aboutHeading || $setup.aboutParagraphs.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("h2", null, _toDisplayString($setup.content.aboutHeading || `Welcome to ${$setup.content.projectName || "your project"}`), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.aboutParagraphs, (paragraph, index) => {
              return (_openBlock(), _createElementBlock("p", { key: index }, _toDisplayString(paragraph), 1))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.content.features?.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Key Features", -1)),
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.features, (feature) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "feature",
                  key: feature
                }, [
                  _createVNode($setup["Check"], { size: 18 }),
                  _createElementVNode("span", null, _toDisplayString(feature), 1)
                ]))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.content.documents?.length)
      ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "Documents", -1)),
            _createElementVNode("div", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.content.documents, (document) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: "document-row",
                  key: document.id,
                  href: document.fileUrl,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("strong", null, _toDisplayString(document.name), 1),
                    _createElementVNode("span", null, _toDisplayString(document.description || document.fileName), 1)
                  ]),
                  _createVNode($setup["Download"], {
                    class: "document-download-icon",
                    size: 20
                  })
                ], 8, _hoisted_15))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.hasContact)
      ? (_openBlock(), _createElementBlock("section", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _cache[6] || (_cache[6] = _createElementVNode("h2", null, "Contact", -1)),
            _createElementVNode("div", _hoisted_19, [
              ($setup.hasContactPerson)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "contact-card",
                    style: _normalizeStyle($setup.contactCardStyle)
                  }, [
                    _createElementVNode("div", _hoisted_20, [
                      ($setup.content.contact?.photoUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: $setup.content.contact.photoUrl,
                            alt: "Contact"
                          }, null, 8, _hoisted_21))
                        : (_openBlock(), _createElementBlock("div", _hoisted_22, [
                            _createVNode($setup["UserRound"], { size: 28 })
                          ])),
                      _createElementVNode("div", null, [
                        _createElementVNode("strong", null, _toDisplayString($setup.content.contact?.name), 1),
                        _createElementVNode("span", null, _toDisplayString($setup.content.contact?.title), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      ($setup.content.contact?.phone)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            href: `tel:${$setup.content.contact.phone}`
                          }, [
                            _createVNode($setup["Phone"], { size: 16 }),
                            _createTextVNode(_toDisplayString($setup.content.contact.phone), 1)
                          ], 8, _hoisted_24))
                        : _createCommentVNode("", true),
                      ($setup.content.contact?.email)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 1,
                            href: `mailto:${$setup.content.contact.email}`
                          }, [
                            _createVNode($setup["Mail"], { size: 16 }),
                            _createTextVNode(_toDisplayString($setup.content.contact.email), 1)
                          ], 8, _hoisted_25))
                        : _createCommentVNode("", true)
                    ])
                  ], 4))
                : _createCommentVNode("", true),
              ($setup.content.locationAddress)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    class: "location-card",
                    href: $setup.googleMapsUrl,
                    target: "_blank",
                    rel: "noopener noreferrer"
                  }, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode($setup["MapPin"], { size: 18 }),
                      _cache[4] || (_cache[4] = _createElementVNode("span", null, "Open in Google Maps", -1))
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createVNode($setup["MapPin"], { size: 17 }),
                      _createElementVNode("div", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Location", -1)),
                        _createElementVNode("span", null, _toDisplayString($setup.content.locationAddress), 1)
                      ])
                    ])
                  ], 8, _hoisted_26))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("section", {
      class: "call-to-action",
      style: _normalizeStyle($setup.ctaStyle)
    }, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("h2", null, _toDisplayString($setup.content.callToAction?.heading || "Ready to Explore?"), 1),
        _createElementVNode("p", null, _toDisplayString($setup.content.callToAction?.subtext || "Get in touch with our sales team to learn more about available lots and pricing."), 1),
        _createElementVNode("a", {
          class: "cta-button",
          href: $setup.masterplanUrl
        }, _toDisplayString($setup.content.callToAction?.buttonText || "View Land Availability"), 9, _hoisted_30)
      ])
    ], 4)
  ]))
}